class CartStore {

	constructor() {
		this.bindActions(this.alt.getActions('cartActions'))
		this.items = window.CART_DATA ? window.CART_DATA.slice(0) : []
	}

	onAddItem(item) {
		this.items.push(item)
	}

	onRemoveItem(item) {
		if(item.modelId) {
			this.items = this.items.filter(i => !(i.productId == item.productId && i.modelId == item.modelId))
		} else {
			this.items = this.items.filter(i => i.productId != item.productId)
		}
	}

}

export default CartStore


/** WEBPACK FOOTER **
 ** ./src/scripts/stores/CartStore.js
 **/